import { render, staticRenderFns } from "./JustificationPanel.vue?vue&type=template&id=b6dbf34a&scoped=true"
import script from "./JustificationPanel.vue?vue&type=script&lang=js"
export * from "./JustificationPanel.vue?vue&type=script&lang=js"
import style0 from "./JustificationPanel.vue?vue&type=style&index=0&id=b6dbf34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dbf34a",
  null
  
)

export default component.exports